// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resetButtonWrapper--UESWQ {
  display: flex;
  justify-content: flex-start;
}

.resetButton--pNRIp {
  color: #111111;
  text-transform: none;
  font-weight: 600;
  min-width: 160px;
  line-height: normal;
}

[dir] .resetButton--pNRIp {
  border-radius: 999px;
  border: 2px solid #eb6f48;
  background-color: #ffffff;
  padding: 6px 24px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SettingsPanel/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EAIE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAEhB,gBAAgB;EAChB,mBAAmB;AACrB;;AAVA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EAIzB,iBAAiB;AAGnB","sourcesContent":[".resetButtonWrapper {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.resetButton {\n  border-radius: 999px;\n  border: 2px solid #eb6f48;\n  background-color: #ffffff;\n  color: #111111;\n  text-transform: none;\n  font-weight: 600;\n  padding: 6px 24px;\n  min-width: 160px;\n  line-height: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resetButtonWrapper": `resetButtonWrapper--UESWQ`,
	"resetButton": `resetButton--pNRIp`
};
export default ___CSS_LOADER_EXPORT___;
